import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PricingPlans } from "./PricingPlans";

interface UpgradeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  feature?: string;
  currentPlan?: string;
  onContinueWithCurrentPlan?: () => void;
}

export function UpgradeDialog({ open, onOpenChange, feature, currentPlan = 'starter', onContinueWithCurrentPlan }: UpgradeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl">Upgrade Your Plan</DialogTitle>
          {feature && (
            <DialogDescription className="text-base">
              You've reached your plan's limit for {feature}. Upgrade to continue using this feature.
            </DialogDescription>
          )}
        </DialogHeader>

        <div className="mt-6">
          <PricingPlans
            currentPlan={currentPlan}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
